import * as React from 'react';
import { Button, EmptyState, Stack } from '@agentisai/design-system';
import { reportError } from '../observability/reportError';

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  static displayName = 'ErrorBoundary';

  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error): void {
    reportError(error, {
      source: 'errorBoundary',
      route: window.location.pathname,
    });
  }

  override render() {
    if (this.state.hasError) {
      return (
        <Stack direction="column" align="center" justify="center" style={{ minHeight: '100vh' }}>
          <EmptyState
            title="Something went wrong"
            description="An unexpected error occurred. Reload the page to try again."
            action={
              <Button variant="primary" onClick={() => window.location.reload()}>
                Reload
              </Button>
            }
          />
        </Stack>
      );
    }
    return this.props.children;
  }
}
